import { render, staticRenderFns } from "./GiftBoxCampaignsMultiSendModal.vue?vue&type=template&id=1ae1574c&scoped=true&"
import script from "./GiftBoxCampaignsMultiSendModal.vue?vue&type=script&lang=js&"
export * from "./GiftBoxCampaignsMultiSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1574c",
  null
  
)

export default component.exports